var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stop",class:_vm.hide ? 'show' : 'hide',style:({ bottom: _vm.bottom })},[_c('div',{staticClass:"btn",style:(_vm.plain ? 'opacity:' + _vm.opacity : 'opacity: 1'),on:{"click":_vm.stop}},[_c('svg-icon',{staticClass:"aiStop t-m-r-5",attrs:{"iconClass":"stop"}}),_c('span',{staticClass:"t-m-l-5"},[_vm._v("停止生成")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }